import OKModal from "@client/controls/Modal/Modals/OK/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export type MapProps = {
  isVisible: boolean;
};
export interface ActionProps {
  onClose: () => void;
}
export type Props = ActionProps & MapProps;

export default (props: Props) => {
  const i18n = useI18n();

  return (
    <OKModal isVisible={props.isVisible} onClose={props.onClose} title={i18n.outOfStock}>
      {i18n.checkoutOutOfStockInformation}
    </OKModal>
  );
};
